import { Navigate, Outlet } from 'react-router-dom';
import { useClientAccess } from './useClientAccess';

/* Route gate for Ask tritonIQ. The Worker enforces the same rule on every
   assistant endpoint; this only keeps the page out of the way for roles that
   cannot use it. */
export function RequireAssistant() {
  const { access, isLoading } = useClientAccess();
  if (isLoading || !access) return null;
  return access.canAssistant ? <Outlet /> : <Navigate to="/" replace />;
}
